import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ApplicationState } from '../store';
import { Notification } from '../types/notification';

export interface AppState {
    alertMessageModalReason: string;
    notifications: Notification[];
}

const initialState: AppState = {
    alertMessageModalReason: '',
    notifications: [],
};

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setAlertMessageModalReason: (state, action: PayloadAction<string>) => {
            state.alertMessageModalReason = action.payload;
        },
        addNotification: (state, action: PayloadAction<Notification[]>) => {
            state.notifications.unshift(...action.payload);
        },
        removeNotification: (state, action: PayloadAction<string>) => {
            state.notifications = [
                ...state.notifications.filter((notification) => notification.id !== action.payload),
            ];
        },
    },
});

export const { setAlertMessageModalReason, addNotification, removeNotification } = appSlice.actions;

export const selectAlertMessageModalReason = (state: ApplicationState) =>
    state.app.alertMessageModalReason;
export const selectNotifications = (state: ApplicationState) => state.app.notifications;
